{
  "greeting": {
    "morning": "Buenos días, {name}",
    "afternoon": "Buenas tardes, {name}",
    "evening": "Buenas noches, {name}",
    "late": "Trabajando tarde, {name}"
  },
  "summary": "Tienes {open} pendientes en {projects} proyectos",
  "progress_completed": "Completado este mes",
  "stats": {
    "open_tasks": "Tareas abiertas",
    "due_today": "Para hoy",
    "due_today_card": "Vencen hoy",
    "overdue": "Vencidas",
    "completed_week": "Completadas esta semana",
    "projects": "Proyectos",
    "collaborators": "Colaboradores"
  },
  "todays_tasks": {
    "title": "Prioridades",
    "view_all": "Ver todas",
    "empty_title": "¡Todo al día!",
    "empty_subtitle": "No tienes tareas vencidas"
  },
  "my_tasks": {
    "title": "Mis tareas",
    "view_all": "Ver todas",
    "empty": "No tienes tareas asignadas. ¡A disfrutar!",
    "due": "Para {date}",
    "no_due": "Sin fecha"
  },
  "collaborators": {
    "title": "Tu equipo",
    "title_short": "Equipo",
    "view_all": "Ver todos",
    "empty": "Invita a alguien para empezar a colaborar.",
    "empty_title": "Sin colaboradores",
    "empty_subtitle": "Invita miembros a tu equipo",
    "open_tasks": "{n} tarea abierta | {n} tareas abiertas",
    "open_count_title": "{n} tarea abierta asignada | {n} tareas abiertas asignadas"
  },
  "recent_projects": {
    "title": "Proyectos recientes",
    "view_all": "Ver todos",
    "empty": "No hay proyectos recientes.",
    "create_first": "Crear el primero",
    "empty_title": "Sin proyectos todavía",
    "empty_subtitle": "Crea tu primer proyecto para empezar",
    "create_action": "Crear proyecto",
    "no_description": "Sin descripción.",
    "tasks_count": "{n} tarea | {n} tareas"
  },
  "oem_modal": {
    "title": "Grabación interrumpida",
    "body": "Tu última grabación se interrumpió porque el sistema cerró Tworks.",
    "body_with_oem": "Esto suele pasar en {label} con el optimizador de batería agresivo.",
    "activate_bypass": "Activar bypass",
    "close": "Cerrar"
  }
}
